/* eslint-disable no-prototype-builtins */

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Slider from '@mui/material/Slider'

import { positionChangeWidthSm, requiredVitalInfoArray, agesArray, gendersArray, pronounsArray, sexualitiesArray, interestedInArray, heightInchesArray, heightCMsArray, religionsArray, politicsArray, ethnicitiesArray, educationLevelsArray, childrenArray, familyPlansArray, alcoholArray, cigarettesArray, weedArray, drugsArray, petsArray, zodiacSignsArray, relationshipTypesArray, datingIntentionsArray, languagesArray, swipelyticsTurquoise } from '../../../helpers/variableDefaults'
import { selectElement, selectMultiple } from '../../../helpers/selects'
import { standardToggle } from '../../../helpers/toggles'
import { cmToInches, inchesToCm, inchesToFeetString } from '../../../helpers/globalHelpers'
import { vitalInfoSetChanges } from '../../../helpers/commonMethods'
import { ageSliderJSX, heightJSX, vitalInfoTextFieldJSX, vitalInfoSelectJSX, vitalInfoSelectMultipleJSX } from '../../../helpers/commonJSX'

export const vitalInfoOnboardingJSX = (
  vitalInfoObject, setVitalInfoObject, 
  loadingVitalInfo, setLoadingVitalInfo,
  vitalInfoErrors, setVitalInfoErrors,
  width
) => {

  const vitalInfoChangeHandler = (e, setErrors, setForm, form) => {
    e.preventDefault()
    // console.log('vitalInfoTextFieldChangeHandler runs')
    const { name, value } = e.target
    // console.log('name ->', name)
    // console.log('value ->', value)

    // console.log('value.length ->', value.length)
    // console.log('typeof value ->', typeof value)
    // console.log('value.charAt(0) ->', value.charAt(0))
    vitalInfoSetChanges(e, setErrors, setForm, form, name, value, vitalInfoObject)
  }

  return (
    <Box
      sx={{
        width: '90%',
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
      }}
    >

      {/* First Name — Textfield (max 30 characters) */}
      {
        requiredVitalInfoArray.includes('firstName') 
        && vitalInfoTextFieldJSX('firstName', 'First Name', 30, 0, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Gender — Select (Male, Female, Non-binary) */}
      {
        requiredVitalInfoArray.includes('gender') 
        && vitalInfoSelectJSX('gender', 'Gender', vitalInfoObject.gender.length < 1 ? ['Nothing selected', ...gendersArray] : gendersArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }

      {/* Sexuality — Select (Straight, Gay, Lesbian, Bisexual, Allosexual, Androsexual, Asexual, Autosexual, Demisexual, Fluid, Graysexual, Gynesexual, Monosexual, Omnisexual, Pansexual, Polysexual, Queer, Questioning, Skoliosexual, Spectrasexual, Not Listed) */}
      {
        requiredVitalInfoArray.includes('sexuality') 
        && vitalInfoSelectJSX('sexuality', 'Sexuality', vitalInfoObject.sexuality.length < 1 ? ['Nothing selected', ...sexualitiesArray] : sexualitiesArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Interested In — Select (Men, Women, Non-binary People, Everyone) */}
      {
        requiredVitalInfoArray.includes('interestedIn') 
        && vitalInfoSelectJSX('interestedIn', 'Interested In', vitalInfoObject.interestedIn.length < 1 ? ['Nothing selected', ...interestedInArray] : interestedInArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Current City — Textfield (max 50 characters; placeholder: 'City, Country') */}
      {
        requiredVitalInfoArray.includes('currentCity') 
        && vitalInfoTextFieldJSX('currentCity', 'Current City', 50, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Hometown — Textfield (max 50 characters; placeholder: 'City, Country') */}
      {
        requiredVitalInfoArray.includes('hometown') 
        && vitalInfoTextFieldJSX('hometown', 'Hometown', 50, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }

      
      {/* University — Textfield (max 50 characters) */}
      {
        requiredVitalInfoArray.includes('university') 
        && vitalInfoTextFieldJSX('university', 'University', 50, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Profession — Textfield (max 50 characters) */}
      {
        requiredVitalInfoArray.includes('profession') 
        && vitalInfoTextFieldJSX('profession', 'Profession', 50, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Employer — Textfield (max 50 characters) */}
      {
        requiredVitalInfoArray.includes('employer') 
        && vitalInfoTextFieldJSX('employer', 'Employer', 50, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Age — Select (min 18, max 99) */}
      {
        requiredVitalInfoArray.includes('age') 
        && 
        <Box
          sx={{ 
            mt: 2, mb: 1,
            width: '100%', 
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {ageSliderJSX(
            'My Age', 
            <span style={{ color: vitalInfoObject.age === -1 ? 'red' : 'blue' }}>{vitalInfoObject.age === -1 ? 'No age selected' : vitalInfoObject.age}</span>, 
            vitalInfoObject.age, 
            'age',
            vitalInfoChangeHandler, 
            setVitalInfoErrors, 
            setVitalInfoObject, 
            vitalInfoObject
          )}
        </Box>
      }


      {/* Height — Select (48 — 90 in; 120 — 230cm) + Radio (in, cm) */}
      {
        (requiredVitalInfoArray.includes('heightInches') || requiredVitalInfoArray.includes('heightCM')) 
        && heightJSX(vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Interested In Age Range — Two-way Slider (Min 18, Max 60+) */}
      {/* {
        requiredVitalInfoArray.includes('interestedInAge') 
        && 
        <Box
          sx={{ 
            mt: 1, mb: 2,
            width: '100%', 
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {ageSliderJSX(
            'Interested-In Age Range', 
            <span style={{ color: 'blue' }}>{vitalInfoObject.interestedInAgeMin} — {vitalInfoObject.interestedInAgeMax}</span>, 
            [vitalInfoObject.interestedInAgeMin, vitalInfoObject.interestedInAgeMax], 
            'interestedInAge',
            vitalInfoChangeHandler, 
            setVitalInfoErrors, 
            setVitalInfoObject, 
            vitalInfoObject
          )}
        </Box>
      } */}


      {/* Pronouns — Select up to 4 (she, her, hers, he, him, his, they, them, theirs, Not listed) */}
      {
        requiredVitalInfoArray.includes('pronouns') 
        && vitalInfoSelectJSX('pronouns', 'Pronouns', vitalInfoObject.pronouns.length < 1 ? ['Nothing selected', ...pronounsArray] : pronounsArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Politics — Select */}
      {
        requiredVitalInfoArray.includes('politics') 
        && vitalInfoSelectJSX('politics', 'Politics', vitalInfoObject.politics.length < 1 ? ['Nothing selected', ...politicsArray] : politicsArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Ethnicity — Select */}
      {
        requiredVitalInfoArray.includes('ethnicity') 
        && vitalInfoSelectJSX('ethnicity', 'Ethnicity', vitalInfoObject.ethnicity.length < 1 ? ['Nothing selected', ...ethnicitiesArray] : ethnicitiesArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Education Level — Select */}
      {
        requiredVitalInfoArray.includes('educationLevel') 
        && vitalInfoSelectJSX('educationLevel', 'Education Level', vitalInfoObject.educationLevel.length < 1 ? ['Nothing selected', ...educationLevelsArray] : educationLevelsArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Children — Select */}
      {
        requiredVitalInfoArray.includes('children') 
        && vitalInfoSelectJSX('children', 'Children', vitalInfoObject.children.length < 1 ? ['Nothing selected', ...childrenArray] : childrenArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Family Plans — Select */}
      {
        requiredVitalInfoArray.includes('familyPlans') 
        && vitalInfoSelectJSX('familyPlans', 'Family Plans', vitalInfoObject.familyPlans.length < 1 ? ['Nothing selected', ...familyPlansArray] : familyPlansArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Alcohol — Select */}
      {
        requiredVitalInfoArray.includes('alcohol') 
        && vitalInfoSelectJSX('alcohol', 'Alcohol', vitalInfoObject.alcohol.length < 1 ? ['Nothing selected', ...alcoholArray] : alcoholArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Cigarettes — Select */}
      {
        requiredVitalInfoArray.includes('cigarettes') 
        && vitalInfoSelectJSX('cigarettes', 'Cigarettes', vitalInfoObject.cigarettes.length < 1 ? ['Nothing selected', ...cigarettesArray] : cigarettesArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Weed — Select */}
      {
        requiredVitalInfoArray.includes('weed') 
        && vitalInfoSelectJSX('weed', 'Weed', vitalInfoObject.weed.length < 1 ? ['Nothing selected', ...weedArray] : weedArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Drugs — Select */}
      {
        requiredVitalInfoArray.includes('drugs') 
        && vitalInfoSelectJSX('drugs', 'Drugs', vitalInfoObject.drugs.length < 1 ? ['Nothing selected', ...drugsArray] : drugsArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Zodiac Sign — Select  */}
      {
        requiredVitalInfoArray.includes('zodiac') 
        && vitalInfoSelectJSX('zodiac', 'Zodiac Sign', vitalInfoObject.zodiac.length < 1 ? ['Nothing selected', ...zodiacSignsArray] : zodiacSignsArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Relationship Type — Select */}
      {
        requiredVitalInfoArray.includes('relationshipType') 
        && vitalInfoSelectJSX('relationshipType', 'Relationship Type', vitalInfoObject.relationshipType.length < 1 ? ['Nothing selected', ...relationshipTypesArray] : relationshipTypesArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Dating Intentions — Select */}
      {
        requiredVitalInfoArray.includes('datingIntentions') 
        && vitalInfoSelectJSX('datingIntentions', 'Dating Intentions', vitalInfoObject.datingIntentions.length < 1 ? ['Nothing selected', ...datingIntentionsArray] : datingIntentionsArray, 1, 1, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, vitalInfoChangeHandler)
      }


      {/* Languages — Multiple Select up to 6 */}
      {
        requiredVitalInfoArray.includes('languages') 
        && vitalInfoSelectMultipleJSX('languages', 'Languages (Up to 6)', false, vitalInfoObject.languages, languagesArray, vitalInfoChangeHandler, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, 1, 1)
      }


      {/* Religion — Select Multiple */}
      {
        requiredVitalInfoArray.includes('religion') 
        && vitalInfoSelectMultipleJSX('religion', 'Religion', false, vitalInfoObject.religion, religionsArray, vitalInfoChangeHandler, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, 1, 1)
      }


      {/* Pets — Select Multiple */}
      {
        requiredVitalInfoArray.includes('pets') 
        && vitalInfoSelectMultipleJSX('pets', 'Pets', false, vitalInfoObject.pets, petsArray, vitalInfoChangeHandler, vitalInfoObject, setVitalInfoObject, setVitalInfoErrors, 0, 1)
      }

    </Box>
  )
}